import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import Helper from '../../../Helper';
import { getTrans as t } from "../../../Localization/translations";

const ContractLeaseSummary = ({
  state,
  currentStep,
  totalSteps,
  data,
  // Step 1 data
  contract_number,
  selectedCustomer,
  billToAddress,
  address_id,
  installAddress,
  reg_address1,
  start_date,
  contract_term,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  lineOfBusiness,
  // Step 2 data
  vendorName,
  vender,
  asset_typeselection,
  vehicle_cost,
  asset_desc,
  // Step 3 data
  frequency,
  paymentrule,
  paymentstart_date,
  amount,
  rowsData,
  iir,
  // Line of Credit data
  credit_line,
  credit_type,
  draw_start_date,
  draw_end_date
}) => {
  // const { t } = useTranslation();

  const formatCurrency = (value) => {
    if (!value) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '';
    try {
      return format(new Date(date), 'MM/dd/yyyy');
    } catch (error) {
      return '';
    }
  };

  const calculateEndDate = () => {
    if (!start_date || !contract_term) return '';
    try {
      const endDate = new Date(start_date);
      endDate.setMonth(endDate.getMonth() + parseInt(contract_term, 10));
      return formatDate(endDate);
    } catch (error) {
      return '';
    }
  };
  // Loan and Line of Credit are collateral-backed, so they use the
  // Collateral wording; Lease and Rental use Installed Location / Asset Type.
  const isCollateralBased = state === 'Loan' || state === 'Line of Credit';
  const [customer, setCustomer] = useState(null);
  const [bill, setBill] = useState([]);
  const [install, setInstall] = useState([]);
  const [vendorData, setVendorData] = useState(null);
  useEffect(() => {
    let customer = data && data.find((val) => val.id === selectedCustomer)
    setCustomer(customer)
    let bill = billToAddress && billToAddress.find((val) => val.value === address_id)
    let billData = bill && bill.label
    setBill(billData)
    let install = installAddress && installAddress.find((val) => val.value === reg_address1)
    let installData = install && install.label
    setInstall(installData)
    let vendorData = vendorName && vendorName.find((val) => val.value === vender)
    setVendorData(vendorData)
  }, [billToAddress, data, installAddress, reg_address1, selectedCustomer, vender, vendorName, address_id])


  return (
    <div className="card shadow-2">
      <div className="card-header bg-opacity-10 py-3">
        <h5 className="card-title mb-0">Contract Summary</h5>
      </div>

      <div className="card-body p-0" style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <div className="p-1 border-bottom">
        </div>

        {/* Step 1 Summary */}
        <div className="p-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-0">{t("Basic Information")}</h6>
          </div>


          <div className="row g-3 mb-2">

          <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Sub Company")}</div>
                <span className="view-label p">{subcompany ? subcompany : ''}</span>
              </div>
            </div>
           
            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Line of Business")}</div>
                <span className="view-label p">{lineOfBusiness ? lineOfBusiness : ''}</span>
              </div>
            </div>

            <div className="col-md-6">
              {/* <div className="p-2 d-flex align-items-center justify-content-between"> */}
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Customer")}</div>
                {/* <div className=" col-form-label">Customer</div> */}
                <span className="view-label p">{customer ? customer.customer_name : ''}</span>
              </div>
            </div>
          </div>
          <div className="row g-3 mb-2">
            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Bill To Address")}</div>
                <span className="view-label p">{bill ? bill : ''}</span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{isCollateralBased ? t("Collateral Location") : t("Installed Location")}</div>
                <span className="view-label p">{install ? install : ''}</span>
              </div>
            </div>
          </div>
          <div className="row g-3 mb-2">
            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Start Date")}</div>
                <span className="view-label p">{start_date ? Helper.DateNormal(start_date) : ''}</span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Term")}</div>
                <span className="view-label p">{contract_term ? contract_term : ''}</span>
              </div>
            </div>

            {state === 'Line of Credit' && (
              <>
                <div className="col-md-6">
                  <div className="p-2">
                    <div className="mb-2 col-form-label">{t("Credit Limit")}</div>
                    <span className="view-label p">{credit_line ? Helper.Amount(credit_line) : ''}</span>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-2">
                    <div className="mb-2 col-form-label">{t("Credit Type")}</div>
                    <span className="view-label p">{credit_type ? t(credit_type) : ''}</span>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-2">
                    <div className="mb-2 col-form-label">{t("Draw Start Date")}</div>
                    <span className="view-label p">{draw_start_date ? Helper.DateNormal(draw_start_date) : ''}</span>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-2">
                    <div className="mb-2 col-form-label">{t("Draw End Date")}</div>
                    <span className="view-label p">{draw_end_date ? Helper.DateNormal(draw_end_date) : ''}</span>
                  </div>
                </div>
              </>
            )}

            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Application Originator")}</div>
                <span className="view-label p">{appOriginator ? appOriginator : ''}</span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Source")}</div>
                <span className="view-label p">{source ? source : ''}</span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">{t("Sales Representative")}</div>
                <span className="view-label p">{salesRep ? salesRep : ''}</span>
              </div>
            </div>
            
            {/* <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">Subcompany</div>
                <span className="view-label p">{subcompany ? subcompany : ''}</span>
              </div>
            </div>
           
            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">Line of Business</div>
                <span className="view-label p">{lineOfBusiness ? lineOfBusiness : ''}</span>
              </div>
            </div> */}
           
            {/* <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">ACH Payments</div>
                <span className="view-label p">{achPayments===true ?  'Yes'  : 'No'}</span>
              </div>
            </div>
           
            <div className="col-md-6">
              <div className="p-2">
                <div className="mb-2 col-form-label">Bank Accounts</div>
                <span className="view-label p">{achAccount ? achAccount : ''}</span>
              </div>
            </div> */}
          </div>
        </div>

        {/* Step 2 Summary */}
        {currentStep >= 2 && (
          <div className="p-3 border-bottom">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">{t("Asset Details")}</h6>
            </div>
            <div className="row g-3 mb-2">
              <div className="col-md-6">
                <div className="p-2">
                  <div className="mb-2 col-form-label">{t("Vendor Name")}</div>
                  <span className="view-label p">{vendorData ? vendorData.label : ''}</span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="p-2">
                  <div className="mb-2 col-form-label">{isCollateralBased ? t("Collateral Type") : t("Asset Type")}</div>
                  <span className="view-label p">{asset_typeselection ? asset_typeselection : ''}</span>
                </div>
              </div>
            </div>
            <div className="row g-3 mb-2">
              {/* {state !== 'Loan' && */}
                <div className="col-md-6">
                  <div className="p-2">
                    <div className="mb-2 col-form-label">{t("Asset Cost")}</div>
                    <span className="view-label p">{vehicle_cost ? Helper.Amount(vehicle_cost) : ''}</span>
                  </div>
                </div>
              {/* } */}
              <div className="col-md-6">
                <div className="p-2">
                  <div className="mb-2 col-form-label">{t("Asset Description")}</div>
                  <span className="view-label p">{asset_desc ? asset_desc : ''}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {rowsData && rowsData.length > 0 && (
  <div className="mb-3">
    <span className="d-block small">Total Payments</span>
    <span className="view-label p">{rowsData.length}</span>
  </div>
)}

{rowsData && rowsData.length > 0 && (
  <div className="mb-3">
    <span className="d-block small">Total Amount</span>
    <span className="fw-bold text-primary">
      {formatCurrency(
        rowsData.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0)
      )}
    </span>
  </div>
)} */}
        {/* Step 3 Summary */}
        {/* {currentStep >= 3 && (
          <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">Payment Details</h6>
            </div>
            {state === 'Loan' &&
              <><div className="mb-2">
                <div className="row align-items-baseline">
                  <div className="col-5 small">Loan Amount</div>
                  {vehicle_cost && (
                    <div className="col-7 view-label p text-end">{vehicle_cost ? vehicle_cost : ''}</div>
                  )}
                </div>
              </div><div className="mb-2">
                  <div className="row align-items-baseline">
                    <div className="col-5 small">Interest Rate</div>
                    {vehicle_cost && (
                      <div className="col-7 view-label p text-end">{iir ? iir : ''} %</div>
                    )}
                  </div>
                </div></>
            }
            <div className="mb-2">
              <div className="row align-items-baseline">
                <div className="col-5 small">Frequency</div>
                <div className="col-7 view-label p text-end">{frequency}</div>
              </div>
            </div>
            {state !== 'Loan' &&
              <div className="mb-2">
                <div className="row align-items-baseline">
                  <div className="col-5 small">Payment Rule</div>
                  <div className="col-7 view-label p text-end">{paymentrule}</div>
                </div>
              </div>
            }
            <div className="mb-2">
              <div className="row align-items-baseline">
                <div className="col-5 small">Payment Start Date</div>
                <div className="col-7 view-label p text-end">{paymentstart_date ? Helper.DateNormal(paymentstart_date) : ''}</div>
              </div>
            </div>
            {state !== 'Loan' &&
              <div className="mb-2">
                <div className="row align-items-baseline">
                  <div className="col-5 small">Payment Amount</div>
                  <div className="col-7 view-label p text-end">{formatCurrency(amount)}</div>
                </div>
              </div>
            }

          </div>
        )} */}
      </div>
    </div>
  );
};

export default ContractLeaseSummary;
